// Shared helpers for opening stock detail views in a new browser tab.
// Used by Ctrl+left-click and middle-button (aux) click on stock entries.

export const stockSummaryPath = (symbol, market) =>
  `/summary?stock=${encodeURIComponent(symbol)}&market=${encodeURIComponent(String(market || '').toUpperCase())}`;

export const openStockInNewTab = (symbol, market) => {
  if (!symbol) return;
  const url = `${window.location.origin}${stockSummaryPath(symbol, market)}`;

  const clickAnchor = () => {
    const a = document.createElement('a');
    a.href = url;
    a.target = '_blank';
    a.rel = 'noopener';
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  const fallbackWindowOpen = () => {
    try {
      window.open(url, '_blank', 'noopener');
    } catch {
      // ignore (e.g. popup blocked or non-browser environment)
    }
  };

  // Chrome treats target="_blank" navigations dispatched from KEYBOARD
  // user activation as "open in new window" (unlike mouse activation,
  // which opens a new tab). We defer the anchor click to the next macrotask
  // so it runs outside the keyboard-event context — user activation is
  // still honored for popup blocking because the deferral is synchronous
  // from the gesture's perspective.
  try {
    setTimeout(clickAnchor, 0);
  } catch {
    fallbackWindowOpen();
  }
};
